<script lang="ts">
  import CreditCardSection from './components/CreditCardSection.svelte';
  import { CreditCardType } from '$lib/models/ccr/types';

  export let clientId: number;

  let visaSection: any;
  let mastercardSection: any;

  // Export save function for parent to call
  export async function saveCCRSettings() {
    await Promise.all([
      visaSection?.saveCCRSettings(),
      mastercardSection?.saveCCRSettings()
    ]);
  }
</script>

<div class="space-y-6 p-4">
  <CreditCardSection
    bind:this={visaSection}
    {clientId}
    creditCardType={CreditCardType.Visa}
    title="VISA"
  />

  <div class="border-t border-gray-200" />

  <CreditCardSection
    bind:this={mastercardSection}
    {clientId}
    creditCardType={CreditCardType.MasterCard}
    title="Mastercard"
  />
</div>